// import axios from 'axios';

// const axiosClient = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   withCredentials: true,
// });

// // Interceptor de solicitud para adjuntar el token de acceso a cada solicitud
// axiosClient.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('authToken');
//     if (token) {
//       config.headers['Authorization'] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Interceptor de respuesta para manejar errores 401 y renovar tokens
// axiosClient.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     // Si el error es 401 y no se ha reintentado aún, intentamos refrescar el token
//     if (error.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;

//       try {
//         // Intentar refrescar el token de acceso
//         const { data } = await axiosClient.post('/api/users/refresh-token');
//         const newAuthToken = data.authToken;

//         // Actualizar el localStorage y los encabezados de solicitud
//         localStorage.setItem('authToken', newAuthToken);
//         axiosClient.defaults.headers['Authorization'] = `Bearer ${newAuthToken}`;
//         originalRequest.headers['Authorization'] = `Bearer ${newAuthToken}`;

//         // Reintentar la solicitud original
//         return axiosClient(originalRequest);
//       } catch (refreshError) {
//         // Si falla la renovación, cerrar sesión del usuario
//         localStorage.removeItem('authToken');
//         window.location.href = '/signin'; // Redirigir al inicio de sesión
//         return Promise.reject(refreshError);
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default axiosClient;

// frontend/src/api/axiosClient.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;
const axiosClient = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// Cliente “limpio” sin interceptor de respuesta, para usar en refresh
const refreshClient = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// Interceptor de solicitud para adjuntar token
axiosClient.interceptors.request.use(config => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

// Interceptor de respuesta para manejar 401
axiosClient.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    const status = error.response?.status;

    // Si no es 401 o ya reintentamos, propagamos el error
    if (status !== 401 || originalRequest._retry) {
      return Promise.reject(error);
    }

    // Si la petición es al propio endpoint de refresh-token, no reintentamos
    if (originalRequest.url?.includes('/api/users/refresh-token')) {
      return Promise.reject(error);
    }

    // Marcamos como reintentada y pedimos un nuevo token
    originalRequest._retry = true;
    try {
      const { data } = await refreshClient.post('/api/users/refresh-token');
      const newAuthToken = data.authToken;

      // Guardamos y actualizamos cabeceras
      localStorage.setItem('authToken', newAuthToken);
      axiosClient.defaults.headers['Authorization'] = `Bearer ${newAuthToken}`;
      originalRequest.headers['Authorization'] = `Bearer ${newAuthToken}`;

      // Reintentamos la petición original
      return axiosClient(originalRequest);
    } catch (refreshError) {
      // Si falla el refresh, limpiamos y dejamos que la app muestre estado “no logueado”
      localStorage.removeItem('authToken');
      return Promise.reject(refreshError);
    }
  }
);

export default axiosClient;

